import React, {useEffect, useState} from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import {getMaintenanceServiceByType} from "../../Integration";

const ServiceOrderForm = ({ isEdit, visible, setVisible, service, options, parseDate}) => {

    const [serviceData, setServiceData,] = useState({
        folio: '',
        fechaCaptura: new Date(),
        usuario: 'ANA IRIS AGUIRRE VELADOR',
        fecha: new Date(),
        proveedor: 'ARCHTS',
        unidad: '260',
        chofer: '',
        kilometraje: 153800,
        entrada: '',
        tipo: 'CORRECTIVO',
        servicio: 'SERVICIO',
        frecuencia: 20000.00,
        proximo: 173800,
        costoPiezas: 3150,
        manoObra: 500,
        subtotal: 3650,
        iva: 584,
        total: 4234,
        notas: 'SERVICIO PREVENTIVO DE MOTOR POR KILOMETRAJE',
        referencia: '',
        activo: true
    });

    const newCaptureDate = new Date().toLocaleDateString('es-MX', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });

    const proveedorOptions = [
        { label: 'ARCHTS', value: 'ARCHTS' },
        { label: 'MECÁNICO A', value: 'MECÁNICO A' },
        { label: 'TALLER B', value: 'TALLER B' }
    ];

    const tipoOptions = [
        { label: 'CORRECTIVO', value: 'CORRECTIVO' },
        { label: 'PREVENTIVO', value: 'PREVENTIVO' },
        { label: 'EMERGENCIA', value: 'EMERGENCIA' }
    ];

    const servicioOptions = [
        { label: 'SERVICIO GENERAL', value: 'SERVICIO' },
        { label: 'CAMBIO DE ACEITE', value: 'CAMBIO_ACEITE' },
        { label: 'REVISIÓN FRENOS', value: 'REVISION_FRENOS' },
        { label: 'MANTENIMIENTO', value: 'MANTENIMIENTO' }
    ];

    useEffect(() => {
        if(isEdit){
            getMaintenanceServiceByType(service.ID_ULTIMO_SERVICIO).then((service) => {
                setServiceData(service);
            }).catch((error) => {
                console.log(error);
            })
        }
    },[isEdit])

    const handleInputChange = (field, value) => {
        setServiceData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleDateChange = (fieldName) => (e) => {
        setServiceData(prevService => ({
            ...prevService,
            [fieldName]: e.value ? e.value.toISOString() : null
        }));
    };

    const handleSave = () => {
        console.log('Guardando:', serviceData);
        setVisible(false);
    };

    const footerContent = (
        <div>
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={() => setVisible(false)}
                className="p-button-text"
            />
            <Button
                label={isEdit ? "Actualizar" : "Guardar"}
                icon="pi pi-check"
                onClick={handleSave}
                autoFocus
            />
        </div>
    );

    return (
        <div className="service-order-container">
            <Dialog
                header={isEdit ? "Editar Orden de Servicio" : "Nueva Orden de Servicio"}
                visible={visible}
                style={{ width: '90vw', maxWidth: '1200px' }}
                onHide={() => setVisible(false)}
                footer={footerContent}
                modal
                resizable={false}
                draggable={false}
            >
                <div className="form-content">
                    {/* Información General */}
                    <div className="section">
                        <h3 className="sectionTitle">
                            <i className="pi pi-info-circle"></i>
                            Información General
                        </h3>
                        <div className="grid grid4">

                            {isEdit && (
                                <>
                                    <div className="fieldGroup">
                                        <label className="label">Folio</label>
                                        <span>{serviceData?.ID}</span>
                                    </div>

                                    <div className="fieldGroup">
                                        <label className="label">Fecha Captura</label>
                                        <span>{serviceData?.FECHA_CAPTURA}</span>
                                    </div>

                                    <div className="fieldGroup">
                                        <label className="label">Usuario</label>
                                        <InputText
                                            value={serviceData?.NOMBRE}
                                            className="readonly-field"
                                            readOnly
                                        />
                                    </div>
                                </>
                            )}

                            <div className="fieldGroup">
                                <label className="label required">Fecha</label>
                                <Calendar
                                    value={parseDate(serviceData?.FECHA)}
                                    onChange={handleDateChange('FECHA')}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    locale="es"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Información del Vehículo */}
                    <div className="section">
                        <h3 className="sectionTitle">
                            <i className="pi pi-car"></i>
                            Información del Vehículo
                        </h3>
                        <div className="grid grid3">
                            <div className="fieldGroup">
                                <label className="label required">Unidad</label>
                                <InputText
                                    value={serviceData?.ID_UNIDAD}
                                    onChange={(e) => handleInputChange('unidad', e.target.value)}
                                    placeholder="Número de unidad"
                                />
                            </div>
                            <div className="fieldGroup">
                                <label className="label">Chofer</label>
                                <InputText
                                    value={serviceData?.CHOFER}
                                    onChange={(e) => handleInputChange('chofer', e.target.value)}
                                    placeholder="Nombre del chofer"
                                />
                            </div>
                            <div className="fieldGroup">
                                <label className="label">Kilometraje</label>
                                <InputNumber
                                    value={serviceData?.KILOMETRAJE}
                                    onValueChange={(e) => handleInputChange('kilometraje', e.value)}
                                    placeholder="Kilometraje actual"
                                    useGrouping
                                />
                            </div>
                        </div>
                    </div>

                    {/* Detalles del Servicio */}
                    <div className="section">
                        <h3 className="sectionTitle">
                            <i className="pi pi-cog"></i>
                            Detalles del Servicio
                        </h3>
                        <div className="categoria-badge">MECÁNICO - ELÉCTRICO</div>

                        <div className="grid grid3">
                            <div className="fieldGroup">
                                <label className="label required">Proveedor</label>
                                <Dropdown
                                    value={serviceData?.ID_PROVEEDOR}
                                    options={proveedorOptions}
                                    onChange={(e) => handleInputChange('proveedor', e.value)}
                                    placeholder="Seleccionar proveedor"
                                />
                            </div>
                            <div className="fieldGroup">
                                <label className="label required">Tipo</label>
                                <Dropdown
                                    value={serviceData?.TIPO}
                                    options={tipoOptions}
                                    onChange={(e) => handleInputChange('tipo', e.value)}
                                />
                            </div>
                            <div className="fieldGroup">
                                <label className="label required">Servicio</label>
                                <Dropdown
                                    value={serviceData?.ID_SERVICIO}
                                    options={servicioOptions}
                                    onChange={(e) => handleInputChange('servicio', e.value)}
                                />
                            </div>
                        </div>

                        <div className="grid grid2" style={{ marginTop: '15px' }}>
                            <div className="fieldGroup">
                                <label className="label">Entrada</label>
                                <InputText
                                    value={serviceData?.ENTRADA}
                                    onChange={(e) => handleInputChange('entrada', e.target.value)}
                                    placeholder="Hora/fecha de entrada"
                                />
                            </div>
                            <div className="fieldGroup">
                                <label className="label">Salida</label>
                                <InputText
                                    placeholder="Hora/fecha de salida"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Frecuencia y Mantenimiento */}
                    <div className="section">
                        <h3 className="sectionTitle">
                            <i className="pi pi-calendar"></i>
                            Frecuencia y Mantenimiento
                        </h3>
                        <div className="grid grid2">
                            {/*<div className="fieldGroup">
                                <label className="label">Frecuencia</label>
                                <InputNumber
                                    value={serviceData?.frecuencia}
                                    onValueChange={(e) => handleInputChange('frecuencia', e.value)}
                                    mode="decimal"
                                    minFractionDigits={2}
                                />
                            </div>*/}
                            <div className="fieldGroup">
                                <label className="label">Próximo</label>
                                <InputNumber
                                    value={serviceData?.PROXIMO}
                                    onValueChange={(e) => handleInputChange('proximo', e.value)}
                                    useGrouping
                                />
                            </div>
                        </div>
                    </div>

                    {/* Costos */}
                    <div className="section">
                        <h3 className="sectionTitle">
                            <i className="pi pi-dollar"></i>
                            Información Financiera
                        </h3>
                        <div className="currency-group">
                            <div className="fieldGroup">
                                <label className="label">Costo Piezas</label>
                                <InputNumber
                                    value={serviceData?.COSTO_PIEZAS}
                                    onValueChange={(e) => handleInputChange('costoPiezas', e.value)}
                                    mode="currency"
                                    currency="MXN"
                                    locale="es-MX"
                                />
                            </div>
                            <div className="fieldGroup">
                                <label className="label">Mano de Obra</label>
                                <InputNumber
                                    value={serviceData?.COSTO_MANO}
                                    onValueChange={(e) => handleInputChange('manoObra', e.value)}
                                    mode="currency"
                                    currency="MXN"
                                    locale="es-MX"
                                />
                            </div>
                            <div className="fieldGroup">
                                <label className="label">SubTotal</label>
                                {/*<InputNumber
                                    value={serviceData?.subtotal}
                                    className="readonly-field"
                                    mode="currency"
                                    currency="MXN"
                                    locale="es-MX"
                                    readOnly
                                />*/}
                            </div>
                        </div>

                        <div className="grid grid3" style={{ marginTop: '15px' }}>
                            <div className="fieldGroup">
                                <label className="label">IVA</label>
                                <div>
                                    <Checkbox
                                        checked={serviceData?.IVA}
                                        onChange={(e) => handleInputChange('IVA', e.checked)}
                                    />
                                    <span style={{ marginLeft: '8px' }}>{serviceData?.IVA}</span>
                                </div>

                            </div>
                            <div className="fieldGroup">
                                <label className="label total-highlight">Total</label>
                                <InputNumber
                                    value={serviceData?.TOTAL}
                                    className="readonly-field total-highlight"
                                    mode="currency"
                                    currency="MXN"
                                    locale="es-MX"
                                    readOnly
                                />
                            </div>
                            <div className="fieldGroup">
                                <label className="label">Estado</label>
                                <div style={{ paddingTop: '8px' }}>
                                    <Checkbox
                                        checked={serviceData?.activo}
                                        onChange={(e) => handleInputChange('activo', e.checked)}
                                    />
                                    <span style={{ marginLeft: '8px' }}>Activo</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Observaciones */}
                    <div className="section">
                        <h3 className="sectionTitle">
                            <i className="pi pi-file-edit"></i>
                            Observaciones y Referencias
                        </h3>
                        <div className="grid grid2">
                            <div className="fieldGroup">
                                <label className="label">Notas</label>
                                <InputTextarea
                                    value={serviceData?.notas}
                                    onChange={(e) => handleInputChange('notas', e.target.value)}
                                    rows={4}
                                    placeholder="Detalles del servicio realizado..."
                                />
                            </div>
                            <div className="fieldGroup">
                                <label className="label">Referencia</label>
                                <InputText
                                    value={serviceData?.referencia}
                                    onChange={(e) => handleInputChange('referencia', e.target.value)}
                                    placeholder="Referencia externa"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default ServiceOrderForm;